var sliderSingle = tns({
	"container": ".slider-sliderSingle",
	"controlsContainer": ".slider-sliderSingle-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"fixedWidth": 320,
	"gutter": 24,
	"center": true,
	"responsive": {
		"768": {
			"fixedWidth": 510
		},
		"992": {
			"controls": true,
			"fixedWidth":628
		},
		"1280": {
			"fixedWidth": 792
		},
		"1366": {
			"fixedWidth": 849
		},
		"1600": {
			"fixedWidth": 1040
		}
	}
});
